exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-25e050da]{background-color:initial}a[data-v-25e050da]{color:inherit!important}.expand-border[data-v-25e050da]{border-left:5px solid #cbcccc!important;margin-left:25px!important;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25e050da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procedure/procedure-view-expand.vue
// module id = 1298
// module chunks = 0